import React, { useState } from 'react';
import styled from 'styled-components';

const DonateContainer = styled.div`
  width: 100%;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  color: #fff;
  text-align: center;
`;

const DonateTitle = styled.h2`
  color: #ff4d00;
  margin-bottom: 15px;
  text-align: center;
`;

const DonateButton = styled.button`
  display: inline-block;
  background: #ff4d00;
  color: #fff;
  padding: 15px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  margin-top: 15px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 77, 0, 0.3);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 30px;
  max-width: 90%;
  width: 500px;
  position: relative;
  box-shadow: 0 5px 30px rgba(255, 77, 0, 0.3);
  border: 2px solid #ff4d00;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #ff4d00;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  line-height: 1;

  &:hover {
    color: #fff;
  }
`;

const ModalTitle = styled.h2`
  color: #ff4d00;
  margin-bottom: 20px;
  font-size: 24px;
  text-align: center;
`;

const ModalText = styled.p`
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.6;
  text-align: center;
`;

const DonateLink = styled.a`
  display: inline-block;
  background: #ff4d00;
  color: #fff;
  padding: 15px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  margin-top: 15px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 77, 0, 0.3);
    background: #ff6a33;
  }
`;

const Donate = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <DonateContainer>
        <DonateTitle>Support LAFD</DonateTitle>
        <p style={{ marginBottom: '20px' }}>Help support the brave firefighters of the Los Angeles Fire Department</p>
        <DonateButton onClick={openModal}>
          Donate Now
        </DonateButton>
      </DonateContainer>

      {isModalOpen && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={e => e.stopPropagation()}>
            <CloseButton onClick={closeModal}>&times;</CloseButton>
            <ModalTitle>Support Our Firefighters</ModalTitle>
            <ModalText>
              Your donation to the Los Angeles Fire Department Foundation helps provide essential equipment, 
              training, and support to our brave firefighters who protect our community every day.
            </ModalText>
            <ModalText>
              The LAFD Foundation is a non-profit organization dedicated to supporting the LAFD in their 
              mission to save lives and protect property.
            </ModalText>
            <div style={{ textAlign: 'center' }}>
              <DonateLink 
                href="https://thegivingblock.com/donate/los-angeles-fire-department-foundation/#npo-cover-section" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Make a Donation
              </DonateLink>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Donate;
